import styled, { css } from 'styled-components';
import ChartCard from '../ChartCard';

export const CustomChartCard = styled(ChartCard)`
  /* min-width: 392px; */
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  border-top: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-30']};
  padding-bottom: 16px;
  margin-top: 16px;
`;

export const Legend = styled.div`
  display: flex;
`;

export const LegendItem = styled.div`
  width: 72px;
  text-align: center;
`;

const SquareBackground = css<{ isTrio?: boolean }>`
  background: ${(props) => props.theme.colors['primary-60']};
`;

export const Square = styled.div<{ isTrio?: boolean }>`
  width: 16px;
  height: 16px;
  margin: 0 auto 16px;
  background: ${(props) => props.theme.colors['secondary-60']};
  ${(props) => props.isTrio && SquareBackground}
`;

export const LegendLabel = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
